// extracted by mini-css-extract-plugin
export default {"imageSection":"Ausstellung_imageSection__y5FS2","imageSectionText":"Ausstellung_imageSectionText__qLVly","imageSectionImage":"Ausstellung_imageSectionImage__gPtcd"};